import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { commonErrorMessage } from 'src/app/constants/error-message-constant';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-save-student-confirmation-dialog',
  templateUrl: './save-student-confirmation-dialog.component.html',
  styleUrls: ['./save-student-confirmation-dialog.component.scss']
})
export class SaveStudentConfirmationDialogComponent implements OnInit {
  errorMessage:any=[];
  constructor(public modalService: NgbActiveModal,private common:CommonService) {this.common.isSystemAlert=true;}
  ngOnInit(): void {
    this.errorMessage=commonErrorMessage;
  }
}
